export default __webpack_public_path__ + "static/media/hide-private-hidden.91227102.svg";